document.querySelectorAll('.location-list-container .store-image-wrapper .image-container-slider').forEach(function (slider) {
  var wrapper = slider.closest('.store-image-wrapper');
  var progressBar = wrapper ? wrapper.querySelector('.progress') : null;
  var progressBarLabel = wrapper ? wrapper.querySelector('.slider__label') : null;

  function updateProgress(slideCount, currentSlide) {
    var calc = ((currentSlide + 1) / slideCount) * 100;
    if (progressBar) {
      progressBar.style.backgroundSize = calc + '% 100%';
      progressBar.setAttribute('aria-valuenow', calc.toFixed(10));
    }
    if (progressBarLabel) progressBarLabel.textContent = calc.toFixed(4) + '% completed';
  }

  slider.addEventListener('slider:init', function (event) {
    var detail = event.detail;
    if (!progressBar) return;
    if (detail.slideCount === 1) {
      progressBar.style.display = 'none';
    } else {
      progressBar.style.display = '';
      updateProgress(detail.slideCount, detail.currentSlide);
    }
  });

  slider.addEventListener('slider:beforeChange', function (event) {
    var detail = event.detail;
    if (detail.slideCount > 1) updateProgress(detail.slideCount, detail.nextSlide);
  });

  CometSlider.init(slider, {
    infinite: false,
    arrows: false,
    dots: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  });

  slider.slick.setPosition();
});

CometSlider.init('#cleaning-step', {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        arrows: false,
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: true,
      }
    }
  ]
}); 

function fadeTo(el, show, duration) {
  if (!el) return;
  el.style.transition = 'opacity ' + duration + 'ms';
  if (show) {
    el.style.display = '';
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    return;
  }
  el.style.opacity = '0';
  window.setTimeout(function () { el.style.display = 'none'; }, duration);
}

if (window.innerWidth < 750) {
  document.querySelectorAll('.shoe-cleaning-step .section-title').forEach(function (title) {
    title.addEventListener('click', function () {
      if (title.classList.contains('active')) {
        title.classList.remove('active');
        document.querySelectorAll('.shoe-cleaning-step .content-and-slider-container')
          .forEach(function (panel) { fadeTo(panel, false, 200); });
        return;
      }
      document.querySelector('#cleaning-step')?.slick?.refresh();
      title.classList.add('active');
      document.querySelectorAll('[data-tab-content="' + title.getAttribute('data-tab-title') + '"]')
        .forEach(function (panel) { fadeTo(panel, true, 200); });
    });
  });
}

// Login tab switcher removed: it bound to markup that is entirely inside
// {% comment %} blocks in sections/login-account.liquid (lines 9-885).

document.addEventListener('DOMContentLoaded', function () {
  let currentPageUrl = window.location.pathname;
  // let splitedUrl = currentPageUrl.split('/');
  
  let sideBarUrl = document.querySelectorAll('.member-account-page .member-page-container .page-list-container ul li a')
  sideBarUrl.forEach((val) => {
    // console.log(typeof val.getAttribute('href'))
    if(val.getAttribute('href') != '' && val.getAttribute('href') != '#'){
      if(currentPageUrl == val.getAttribute('href')){
        val.classList.add('active');
      }
    }
  });
});

// login ends



document.addEventListener('DOMContentLoaded', function () {
  function initializeSlick() {
    CometSlider.init('.grid-image-slider', {
      speed: 300,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  // 500ms delay outruns the ~30 other listeners that mutate the grid first.
  document.addEventListener("filter:product:grid:updated", function () {
    setTimeout(() => {
      initializeSlick();
    }, 500);
  });

  // Deliberately synchronous - global.js has already swapped the markup.
  document.addEventListener("recommend:product:grid:image:slider", function () {
    initializeSlick();
  });

  initializeSlick();
});